function DPData() {
    const currentDate = Date.now();

    return [
        {
            name: 'Today',
            value: 'today',
            startDate: currentDate,
            endDate: currentDate,
        },
        {
            name: 'This Week',
            value: 'thisWeek',
            startDate: currentDate,
            endDate: currentDate,
        },
        {
            name: 'Last Month',
            value: 'lastMonth',
            startDate: currentDate,
            endDate: currentDate,
        },
        {
            name: 'This Year',
            value: 'thisYear',
            startDate: currentDate,
            endDate: currentDate,
        },
    ];
}

export default DPData();
